/* tslint:disable */
/* eslint-disable */
/**
 * Conversation Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface HasEventResponse
 */
export interface HasEventResponse {
    /**
     * 
     * @type {boolean}
     * @memberof HasEventResponse
     */
    hasEvents: boolean;
}

/**
 * Check if a given object implements the HasEventResponse interface.
 */
export function instanceOfHasEventResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "hasEvents" in value;

    return isInstance;
}

export function HasEventResponseFromJSON(json: any): HasEventResponse {
    return HasEventResponseFromJSONTyped(json, false);
}

export function HasEventResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): HasEventResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'hasEvents': json['has_events'],
    };
}

export function HasEventResponseToJSON(value?: HasEventResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'has_events': value.hasEvents,
    };
}

